import React, { useState, useMemo } from "react";
import FlexBetween from "components/FlexBetween";
import Header from "components/Header";
import {
  Box,
  useMediaQuery,
  TextField,
  MenuItem,
} from "@mui/material";
import { useGetDashboardQuery } from "state/api";
import {
  formatDateToDDMMYYYY,
  convertToYYYYMMDD,
  getCurrentMonthPeriod,
  getMonthPeriodFromDate,
} from "utils/dateUtils";
import TotalPaidAmountDisplay from "components/dashboard/TotalPaidAmountDisplay";
import ConsumptionLineChart from "components/dashboard/ConsumptionLineChart";
import DataGridComponent from "components/dashboard/DataGridComponent";
import { dashboardColumns } from "components/dashboard/dashboardColumns";
import useDashboardData from "hooks/useDashboardData";


const Dashboard = () => {
  const handleMonthChange = (inputValue) => {
    const ddmmyyyy = formatDateToDDMMYYYY(inputValue);
    const period = getMonthPeriodFromDate(ddmmyyyy);

    setStartDate(period.startDate);
    setEndDate(period.endDate);
  };
  const isNonMediumScreens = useMediaQuery("(min-width: 1200px)");
  const { isLoading } = useGetDashboardQuery();
  const defaultPeriod = getCurrentMonthPeriod();
  const [searchQuery, setSearchQuery] = useState("");

  const [startDate, setStartDate] = useState(defaultPeriod.startDate);
  const [endDate, setEndDate] = useState(defaultPeriod.endDate);
  const [paymentStatusFilter, setPaymentStatusFilter] = useState("");

  const {
    consommations,
    totalPaidAmount,
    formattedData,
    noResultsMessage,
  } = useDashboardData({
    searchQuery,
    startDate,
    endDate,
    paymentStatusFilter,
  });

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handlePaymentStatusChange = (e) => {
    setPaymentStatusFilter(e.target.value);
  };

  const memoizedData = useMemo(() => formattedData, [formattedData]);

  return (
    <Box m="1.5rem 2.5rem">
      <FlexBetween
        sx={{
          flexDirection: {
            xs: "column",
            md: "row",
          },
          alignItems: {
            xs: "flex-start",
            md: "center",
          },
          gap: {
            xs: "1.5rem",
            md: "0",
          },
        }}
      >
        <Header
          title="TABLEAU DE BORD"
          subtitle="Bienvenue sur votre tableau de bord"
        />
        <Box
          display="flex"
          gap="20px"
          flexWrap="wrap"
          justifyContent="flex-start"
          sx={{
            width: {
              xs: "100%",
              md: "auto",
            },
          }}
        >
          <TextField
            type="text"
            label="Rechercher..."
            value={searchQuery}
            onChange={handleSearchChange}
            sx={{
              width: {
                xs: "100%",
                sm: "200px",
              },
            }}
          />
          <TextField
            type="date"
            label="Start Date"
            value={convertToYYYYMMDD(startDate)}
            onChange={(e) => handleMonthChange(e.target.value)}
            sx={{
              width: {
                xs: "100%",
                sm: "180px",
              },
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />

          <TextField
            type="date"
            label="End Date"
            value={convertToYYYYMMDD(endDate)}
            onChange={(e) => handleMonthChange(e.target.value)}
            sx={{
              width: {
                xs: "100%",
                sm: "180px",
              },
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            select
            label="Statut de Paiement"
            value={paymentStatusFilter}
            onChange={handlePaymentStatusChange}
            sx={{
              width: {
                xs: "100%",
                sm: "200px",

              },
              minWidth: "120px",
            }}
          >
            <MenuItem value="">Tous</MenuItem>
            <MenuItem value="payé">Payé</MenuItem>
            <MenuItem value="impayé">Impayé</MenuItem>
          </TextField>
        </Box>
      </FlexBetween>
      <Box
        mt="20px"
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="160px"
        gap="20px"
        sx={{
          "& > div": {
            gridColumn: isNonMediumScreens ? undefined : "span 12",
          },
        }}
      >
        <DataGridComponent
          isLoading={isLoading}
          consommations={consommations}
          columns={dashboardColumns}
          noResultsMessage={noResultsMessage}
        />
        <TotalPaidAmountDisplay totalPaidAmount={totalPaidAmount} />
        <ConsumptionLineChart memoizedData={memoizedData} />
      </Box>
    </Box>
  );
};

export default Dashboard;

